<template>
  <a-modal
    width="600px"
    title="Accept Violation"
    :visible="visible"
    :destroy-on-close="true"
    :data-testid="`${testIdPrefix}-accept-modal`"
    @cancel="cancel"
  >
    <div class="flex flex-column gap-3" :data-testid="`${testIdPrefix}-accept-content`">
      <a-input
        placeholder="Optional"
        :value="comment"
        :disabled="loading"
        :data-testid="`${testIdPrefix}-accept-comment-input`"
        @input="$emit('update:comment', $event)"
      />

      <div :data-testid="`${testIdPrefix}-accept-disciplinary-actions`">
        <b>Disciplinary actions</b>
        <a-checkbox-group v-model="selectedActions" :disabled="loading" class="flex flex-column gap-2 mt-2">
          <a-checkbox
            v-for="action in disciplinaryActions"
            :key="action.value"
            :value="action.value"
            :data-testid="`${testIdPrefix}-accept-disciplinary-${action.value}-checkbox`"
          >
            {{ action.label }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </div>

    <template slot="footer">
      <div class="flex justify-content-between" :data-testid="`${testIdPrefix}-accept-footer`">
        <a-button :disabled="loading" :data-testid="`${testIdPrefix}-accept-cancel-button`" @click="cancel">
          Cancel
        </a-button>
        <div class="flex justify-content-end gap-2">
          <a-button
            type="primary"
            :loading="loading && submittedMode === 'plain'"
            :disabled="loading || selectedActions.length > 0"
            :data-testid="`${testIdPrefix}-accept-button`"
            @click="plainAccept"
          >
            Accept
          </a-button>
          <a-button
            type="primary"
            :loading="loading && submittedMode === 'disciplinary'"
            :disabled="loading || !selectedActions.length"
            :data-testid="`${testIdPrefix}-accept-disciplinary-button`"
            @click="disciplinaryAccept"
          >
            Accept and Disciplinary Action
          </a-button>
          <a-button
            v-if="showAdjust"
            type="primary"
            :loading="loading && submittedMode === 'adjust'"
            :disabled="loading || selectedActions.length > 0"
            :data-testid="`${testIdPrefix}-accept-adjust-button`"
            @click="adjustAccept"
          >
            Accept &amp; Adjust
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { Button, Checkbox, Input, Modal } from 'ant-design-vue'

const DISCIPLINARY_ACTIONS = Object.freeze([
  { label: 'Written Warning', value: 'written_warning' },
  { label: 'Notification', value: 'alert' },
  { label: 'Block', value: 'block' },
  { label: 'Suspension', value: 'shift_penalty' }
])

export default {
  components: {
    'a-modal': Modal,
    'a-button': Button,
    'a-input': Input,
    'a-checkbox-group': Checkbox.Group,
    'a-checkbox': Checkbox
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    comment: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    showAdjust: {
      type: Boolean,
      default: false
    },
    testIdPrefix: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      disciplinaryActions: DISCIPLINARY_ACTIONS,
      selectedActions: [],
      submittedMode: undefined
    }
  },
  watch: {
    visible() {
      this.selectedActions = []
      this.submittedMode = undefined
    },
    loading(value) {
      if (!value) this.submittedMode = undefined
    }
  },
  methods: {
    cancel() {
      if (this.loading) return

      this.$emit('update:visible', false)
      this.$emit('update:comment', '')
    },
    plainAccept() {
      if (!this.loading) {
        this.submittedMode = 'plain'
        this.$emit('plain-accept')
      }
    },
    disciplinaryAccept() {
      if (!this.loading && this.selectedActions.length) {
        this.submittedMode = 'disciplinary'
        this.$emit('disciplinary-accept', [...this.selectedActions])
      }
    },
    adjustAccept() {
      if (!this.loading) {
        this.submittedMode = 'adjust'
        this.$emit('accept-and-adjust')
      }
    }
  }
}
</script>
